import styled from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  background: ${Theme.color.surface.light};
  border: 0.2px solid ${Theme.color.border.subtle};
  border-radius: ${Theme.border.borderRadius.md};

  &:hover {
    box-shadow: ${Theme.shadow.card};
  }

  cursor: pointer;
  transition: 0.2s;
`;

const ImageWrap = styled.div`
  width: 100%;
  height: 240px;
  overflow: hidden;
  position: relative;
  background: ${Theme.color.background.mid};
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0.88;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;

  ${Wrapper}:hover & {
    opacity: 1;
    transform: scale(1.03);
  }
`;

const CardNum = styled.span`
  position: absolute;
  top: 14px;
  left: 14px;
  padding: 4px 8px;
  color: ${Theme.color.text.inverse};
  font-size: ${Theme.font.fontSize.sm};
  background: ${Theme.color.text.primary};
  font-family: ${Theme.font.fontFamily.heading};
  font-weight: ${Theme.font.fontWeight.semiBold};
  border-radius: ${Theme.border.borderRadius.sm};
  letter-spacing: ${Theme.font.letterSpacing.widest};
`;

const CardBody = styled.div`
  padding: 28px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  border-top: 2px solid ${Theme.color.border.light};
  transition: border-color 0.15s ease;

  ${Wrapper}:hover & {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border-top-color: ${Theme.color.text.primary};
  }

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    padding: 20px 16px;
  }
`;

const CardTitle = styled.h3`
  margin: 0 0 10px;
  text-transform: uppercase;
  color: ${Theme.color.text.heading};
  font-size: ${Theme.font.fontSize.xxl};
  font-family: ${Theme.font.fontFamily.heading};
  font-weight: ${Theme.font.fontWeight.bold};
  letter-spacing: ${Theme.font.letterSpacing.wide};
  line-height: ${Theme.font.lineHeight.tight};
`;

const CardDesc = styled.p`
  flex: 1;
  margin: 0;
  color: ${Theme.color.text.secondary};
  font-size: ${Theme.font.fontSize.base};
  line-height: ${Theme.font.lineHeight.relaxed};
`;

function ServiceCard({ service }) {
  return (
    <Wrapper key={service.id}>
      <ImageWrap>
        <CardImage src={service.img} alt={service.title} />
        <CardNum>{service.id}</CardNum>
      </ImageWrap>

      <CardBody>
        <CardTitle>{service.title}</CardTitle>
        <CardDesc>{service.desc}</CardDesc>
      </CardBody>
    </Wrapper>
  );
}

export default ServiceCard;
